import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import CollegeComponent from './CollegeComponent';
import HighschoolComponent from './HighschoolComponent';

// ES6 classNameNameNameName-style
class StudentComponent extends PreLoginSessionCheck {

  constructor(props) {
    super(props);
    this.state = {
      currentTab: "highschool"
    }
  }

  setTab = (key) => {
    this.setState({ currentTab: key });
  }

  ControlledTabs = () => {
    return (
      <Tabs
        id="teampage-tab"
        activeKey={this.state.currentTab}
        onSelect={(k) => this.setTab(k)}>
        <Tab eventKey="highschool" title="High School Interns">
          <HighschoolComponent></HighschoolComponent>
        </Tab>
        <Tab eventKey="college" title="College Interns">
          <CollegeComponent></CollegeComponent>
        </Tab>
      </Tabs>
    );
  }


  componentDidMount() {

  }

  render() {
    return (
      <div>
        <div className="header">
          <p>If you are a high school or college student who is curious to know how it is like to work in the real world, you could experience this through an internship at HeyMath!</p>
          <p>We have had students intern with us for just a week up to a period of 6 months. Depending on your talents and interests, you can deep dive into a wide range of exciting projects in maths, science, programming, animation or even be a voice artist or test drive our new products and features.</p>
        </div>
        {this.ControlledTabs()}
      </div>
    );
  }
}

export default StudentComponent;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/StudentComponent.js